package com.fireavert.api_routes

object EventRoutesList {

    const val DELETE_EVENT_HISTORY_FOR_UNIT = "${UNITS_BASE}/{id}/event_history"
    const val DELETE_SINGLE_EVENT_FROM_HISTORY = "${EVENTS_BASE}/{id}/deleteFromHistory"
    const val MARK_AS_FALSE_ALARM = "${EVENTS_BASE}/{id}/markAsFalseAlarm"
    const val EVENT_AND_ACTIONS = "${API_BASE}/eventsAndActions"
    const val EVENTS_BY_UNIT = "${UNITS_BASE}/{id}/event_history"
    const val MARK_AS_TEST = "${EVENTS_BASE}/{id}/markAsTest"
    const val DISMISS_EVENT = "${EVENTS_BASE}/{id}/dismiss"


    fun deleteEventHistoryForUnit(id: Int): String {
        return DELETE_EVENT_HISTORY_FOR_UNIT.replace("{id}", id.toString())
    }

    fun deleteSingleEventFromHistory(id: Int): String {
        return DELETE_SINGLE_EVENT_FROM_HISTORY.replace("{id}", id.toString())
    }

    fun markAsFalseAlarm(id: Int): String {
        return MARK_AS_FALSE_ALARM.replace("{id}", id.toString())
    }

    fun eventsByUnit(id: Int): String {
        return EVENTS_BY_UNIT.replace("{id}", id.toString())
    }

    fun markAsTest(id: Int): String {
        return MARK_AS_TEST.replace("{id}", id.toString())
    }

    fun dismissEvent(id: Int): String {
        return DISMISS_EVENT.replace("{id}", id.toString())
    }
}